import { useLang } from '@/i18n';
import styles from './index.module.scss';
import EfImg from '@elem/ui/ef-img';
import EfSpec from '@elem/ui/ef-spec';
import R3Slogan from './icons/R3Slogan';
import R2Slogan from './icons/R2Slogan';
import Circle from './icons/Circle';
import Star from './icons/Star';
import { useEffect, useState } from 'react';

type IconType = {
    icon: JSX.Element;
    text: string;
};

type InfoType = {
    title: string;
    desc?: string;
};

type ListType = {
    props: string;
    info: InfoType[];
};

type ItemType = {
    title: string;
    slogan: IconType;
    new?: IconType;
    img: string;
    lists: ListType[];
};
export default function TheComp() {
    const { t } = useLang('theProduct');
    const [isH5, setIsH5] = useState(false);

    const items: ItemType[] = [
        {
            title: t('I_p1'),
            slogan: {
                icon: <R3Slogan />,
                text: t('I_p1_slogan'),
            },
            new: {
                icon: <Circle />,
                text: t('I_new'),
            },
            img: 'https://websiteoss.ecoflow.com/upload/image/1737706917452/R3.png',
            lists: [
                {
                    props: t('I_props1'),
                    info: [
                        {
                            title: t('I_p1_item1_title'),
                        },
                    ],
                },
                {
                    props: t('I_props2'),
                    info: [
                        {
                            title: t('I_p1_item2_title'),
                        },
                    ],
                },
                {
                    props: t('I_props3'),
                    info: [
                        {
                            title: t('I_p1_item3_title'),
                        },
                    ],
                },
                {
                    props: t('I_props4'),
                    info: [
                        {
                            title: t('I_p1_item4_title1'),
                            desc: t('I_p1_item4_desc1'),
                        },
                        {
                            title: t('I_p1_item4_title2'),
                            desc: t('I_p1_item4_desc2'),
                        },
                        {
                            title: t('I_p1_item4_title3'),
                            desc: t('I_p1_item4_desc3'),
                        },
                        {
                            title: t('I_p1_item4_title4'),
                            desc: t('I_p1_item4_desc4'),
                        },
                    ],
                },
                {
                    props: t('I_props5'),
                    info: [
                        {
                            title: t('I_p1_item5_title1'),
                            desc: t('I_p1_item5_desc1'),
                        },
                        {
                            title: t('I_p1_item5_title2'),
                            desc: t('I_p1_item5_desc2'),
                        },
                    ],
                },
                {
                    props: t('I_props6'),
                    info: [
                        {
                            title: t('I_p1_item6_title'),
                        },
                    ],
                },
                {
                    props: t('I_props7'),
                    info: [
                        {
                            title: t('I_p1_item7_title'),
                        },
                    ],
                },
                {
                    props: t('I_props8'),
                    info: [
                        {
                            title: t('I_p1_item8_title'),
                        },
                    ],
                },
            ],
        },
        {
            title: t('I_p2'),
            slogan: {
                icon: <R2Slogan />,
                text: t('I_p2_slogan'),
            },
            img: 'https://websiteoss.ecoflow.com/upload/image/1737706917691/R2.png',
            lists: [
                {
                    props: t('I_props1'),
                    info: [
                        {
                            title: t('I_p2_item1_title'),
                        },
                    ],
                },
                {
                    props: t('I_props2'),
                    info: [
                        {
                            title: t('I_p2_item2_title'),
                        },
                    ],
                },
                {
                    props: t('I_props3'),
                    info: [
                        {
                            title: t('I_p2_item3_title'),
                        },
                    ],
                },
                {
                    props: t('I_props4'),
                    info: [
                        {
                            title: t('I_p2_item4_title1'),
                            desc: t('I_p2_item4_desc1'),
                        },
                        {
                            title: t('I_p2_item4_title2'),
                            desc: t('I_p2_item4_desc2'),
                        },
                        {
                            title: t('I_p2_item4_title3'),
                            desc: t('I_p2_item4_desc3'),
                        },
                        {
                            title: t('I_p2_item4_title4'),
                            desc: t('I_p2_item4_desc4'),
                        },
                    ],
                },
                {
                    props: t('I_props5'),
                    info: [
                        {
                            title: t('I_p2_item5_title1'),
                            desc: t('I_p2_item5_desc1'),
                        },
                        {
                            title: t('I_p2_item5_title2'),
                            desc: t('I_p2_item5_desc2'),
                        },
                    ],
                },
                {
                    props: t('I_props6'),
                    info: [
                        {
                            title: t('I_p2_item6_title'),
                        },
                    ],
                },
                {
                    props: t('I_props7'),
                    info: [
                        {
                            title: t('I_p2_item7_title'),
                        },
                    ],
                },
                {
                    props: t('I_props8'),
                    info: [
                        {
                            title: t('I_p2_item8_title'),
                        },
                    ],
                },
            ],
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsH5(window.innerWidth < 768);
        }
    }, []);

    return (
        <div className={styles.comp}>
            <EfSpec />
            <p className="title">{t('I_title')}</p>
            {!isH5 && (
                <div className="box">
                    <table className="table">
                        <thead className="thead">
                            <tr className="tr">
                                <th className="th">
                                    <p className="th-title">{t('I_p1')}</p>
                                    <div className="img-box">
                                        <EfImg className="product-img" pc="https://websiteoss.ecoflow.com/upload/image/1737706917452/R3.png" />
                                        <div className="slogan-box">
                                            <R3Slogan />
                                            <p className="slogan-text">{t('I_p1_slogan')}</p>
                                        </div>
                                        <div className="new-circle">
                                            <Circle />
                                            <Star />
                                            {/* <p className="new-text">{t('I_new')}</p> */}
                                        </div>
                                    </div>
                                </th>
                                <th className="th"></th>
                                <th className="th">
                                    <p className="th-title">{t('I_p2')}</p>
                                    <div className="img-box">
                                        <EfImg className="product-img" pc="https://websiteoss.ecoflow.com/upload/image/1737706917691/R2.png" />
                                        <div className="slogan-box">
                                            <R2Slogan />
                                            <p className="slogan-text">{t('I_p2_slogan')}</p>
                                        </div>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody className="tbody">
                            <tr className="tr">
                                <td className="td">
                                    <p className="td-title">{t('I_p1_item1_title')}</p>
                                </td>
                                <td className="td">{t('I_props1')}</td>
                                <td className="td">
                                    <p className="td-title">{t('I_p2_item1_title')}</p>
                                </td>
                            </tr>
                            <tr className="tr">
                                <td className="td">
                                    <p className="td-title">{t('I_p1_item2_title')}</p>
                                </td>
                                <td className="td">{t('I_props2')}</td>
                                <td className="td">
                                    <p className="td-title transparent">{t('I_p2_item2_title')}</p>
                                </td>
                            </tr>
                            <tr className="tr">
                                <td className="td">
                                    <p className="td-title transparent">{t('I_p1_item3_title')}</p>
                                </td>
                                <td className="td">{t('I_props3')}</td>
                                <td className="td">
                                    <p className="td-title">{t('I_p2_item3_title')}</p>
                                </td>
                            </tr>
                            <tr className="tr">
                                <td className="td">
                                    <p className="td-title">{t('I_p1_item4_title1')}</p>
                                    <p className="td-desc">{t('I_p1_item4_desc1')}</p>
                                    <p className="td-title">{t('I_p1_item4_title2')}</p>
                                    <p className="td-desc">{t('I_p1_item4_desc2')}</p>
                                    <p className="td-title">{t('I_p1_item4_title3')}</p>
                                    <p className="td-desc">{t('I_p1_item4_desc3')}</p>
                                    <p className="td-title">{t('I_p1_item4_title4')}</p>
                                    <p className="td-desc">{t('I_p1_item4_desc4')}</p>
                                </td>
                                <td className="td">{t('I_props4')}</td>
                                <td className="td">
                                    <p className="td-title">{t('I_p2_item4_title1')}</p>
                                    <p className="td-desc">{t('I_p2_item4_desc1')}</p>
                                    <p className="td-title">{t('I_p2_item4_title2')}</p>
                                    <p className="td-desc">{t('I_p2_item4_desc2')}</p>
                                    <p className="td-title">{t('I_p2_item4_title3')}</p>
                                    <p className="td-desc">{t('I_p2_item4_desc3')}</p>
                                    <p className="td-title">{t('I_p2_item4_title4')}</p>
                                    <p className="td-desc">{t('I_p2_item4_desc4')}</p>
                                </td>
                            </tr>
                            <tr className="tr">
                                <td className="td">
                                    <p className="td-title">{t('I_p1_item5_title1')}</p>
                                    <p className="td-desc">{t('I_p1_item5_desc1')}</p>
                                    <p className="td-title">{t('I_p1_item5_title2')}</p>
                                    <p className="td-desc">{t('I_p1_item5_desc2')}</p>
                                </td>
                                <td className="td">{t('I_props5')}</td>
                                <td className="td">
                                    <p className="td-title">{t('I_p2_item5_title1')}</p>
                                    <p className="td-desc">{t('I_p2_item5_desc1')}</p>
                                    <p className="td-title">{t('I_p2_item5_title2')}</p>
                                    <p className="td-desc">{t('I_p2_item5_desc2')}</p>
                                </td>
                            </tr>
                            <tr className="tr">
                                <td className="td">
                                    <p className="td-title">{t('I_p1_item6_title')}</p>
                                </td>
                                <td className="td">{t('I_props6')}</td>
                                <td className="td">
                                    <p className="td-title transparent">{t('I_p2_item6_title')}</p>
                                </td>
                            </tr>
                            <tr className="tr">
                                <td className="td">
                                    <p className="td-title">{t('I_p1_item7_title')}</p>
                                </td>
                                <td className="td">{t('I_props7')}</td>
                                <td className="td">
                                    <p className="td-title transparent">{t('I_p2_item7_title')}</p>
                                </td>
                            </tr>
                            <tr className="tr">
                                <td className="td">
                                    <p className="td-title transparent">{t('I_p1_item8_title')}</p>
                                </td>
                                <td className="td">{t('I_props8')}</td>
                                <td className="td">
                                    <p className="td-title">{t('I_p2_item8_title')}</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}
            {isH5 && (
                <ul className="items">
                    {items.map((item: ItemType, k: number) => (
                        <li className="item" key={k}>
                            <div className="item-header">
                                <div className="item-img">
                                    <EfImg pc={item.img} />
                                </div>
                                <div className="item-slogan">
                                    <p className="item-title">{item.title}</p>
                                    <div className="slogan-box">
                                        <div className="slogan-icon">{item.slogan.icon}</div>
                                        <p className="slogan-text">{item.slogan.text}</p>
                                    </div>
                                </div>
                                {item?.new && (
                                    <div className="new-circle">
                                        {item.new.icon}
                                        <Star />
                                        {/* <p className="new-text">{item.new.text}</p> */}
                                    </div>
                                )}
                            </div>
                            <ul className="item-lists">
                                {item.lists.map((list: ListType, m: number) => (
                                    <li className="item-list" key={k + '_' + m}>
                                        <p className="item-list-props">{list.props}</p>
                                        <ul className="item-list-subs">
                                            {list.info.map((info: InfoType, n: number) => (
                                                <li className="item-list-sub" key={k + '_' + m + '_' + n}>
                                                    <p className="item-list-sub-title">{info.title}</p>
                                                    {info?.desc && <p className="item-list-sub-desc">{info.desc}</p>}
                                                </li>
                                            ))}
                                        </ul>
                                    </li>
                                ))}
                            </ul>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
